import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox } from "@mui/material";
import { Eye } from "lucide-react";

const columnHelper = createColumnHelper<any>();

export const BaliffOverviewColumns = [
  columnHelper.accessor("sn", {
    header: "SN",
    cell: ({ row }) => (
      <Checkbox
        color="success"
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
        sx={{
          color: "#E0E0E0",
          "&.Mui-checked": {
            color: "#00B074",
          },
        }}
      />
    ),
  }),
  columnHelper.accessor("date_assigned", {
    header: "Date assigned",
    cell: (info) => <span className="text-[#667085]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("title", {
    header: "Title",
    cell: (info) => (
      <span className="text-[#101828] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("suit_number", {
    header: "Suit number",
    cell: (info) => (
      <span className="text-[#101828] font-semibold">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("details", {
    header: "Details",
    cell: () => (
      <button className="flex items-center gap-1 text-[#101828] hover:text-[#00B074]">
        <span>View</span>
        <Eye className="w-4 h-4" />
      </button>
    ),
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (info) => (
      <span className="text-[#D97706] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("time_spent", {
    header: "Time Spent",
    cell: (info) => (
      <span className="text-[#00B074] font-medium">{info.getValue()}</span>
    ),
  }),
];
